import React from 'react';
import { Box, Typography, Button, Grid, Divider } from '@mui/material';
import PageCard from './PageCard';

const TabPagina = ({ paginas, irA, eliminar }) => {
  const drafts = paginas.filter(p => p.borrador);
  const published = paginas.filter(p => !p.borrador);
  const independent = published.filter(p => (p.miembros || []).length <= 1);
  const groups = published.filter(p => (p.miembros || []).length > 1);

  return (
    <Box sx={{ mt: 3 }}>
      {/* Drafts Section */}
      {drafts.length > 0 && (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" color="#0E2465">
            Borradores
          </Typography>
          <Typography color="#737791" sx={{ mb: 2 }}>
            Completa la información de tu servicio para publicarlo
          </Typography>

          {drafts.map(page => (
            <PageCard
              key={page._id}
              page={page}
              type="DRAFT"
              onEdit={() => irA(`/user/crear-servicio/1?draft=${page._id}`)} // Adjust route needed
              onView={() => irA(`/user/pagina/${page._id}`)}
              onDelete={() => eliminar(page._id)}
            />
          ))}
        </Box>
      )}

      {/* Independent Section */}
      <Box sx={{ mb: 6 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" fontWeight="bold" color="#0E2465">
            Mis páginas de Servicios Independientes
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: 'none', bgcolor: '#0E2465' }}
            onClick={() => irA('/user/crear-servicio/1?type=independent')}
          >
            Nueva página independiente
          </Button>
        </Box>
        <Typography color="#737791" sx={{ mb: 2 }}>
          Tus páginas donde eres el único profesional
        </Typography>

        {independent.length === 0 ? (
          <Typography sx={{ mt: 2, color: "#94A3B8" }}>
            No tienes páginas independientes aún.
          </Typography>
        ) : (
          independent.map(page => (
            <PageCard
              key={page._id}
              page={page}
              type="PUBLISHED"
              onEdit={() => irA(`/user/crear-servicio/1?edit=${page._id}&type=independent`)}
              onView={() => irA(`/user/pagina/${page._id}`)} // Adjust route
              onDelete={() => eliminar(page._id)}
            />
          ))
        )}
      </Box>

      {/* Groups Section */}
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" fontWeight="bold" color="#0E2465">
            Mis páginas de Grupos y Negocios
          </Typography>
          <Button
            variant="contained"
            sx={{ textTransform: 'none', bgcolor: '#0E2465', '&:hover': { bgcolor: '#0a1a4a' } }}
            onClick={() => irA('/user/crear-servicio/1?type=group')}
          >
            Nueva página de grupo
          </Button>
        </Box>
        <Typography color="#737791" sx={{ mb: 2 }}>
          Tus páginas con equipos y colaboradores
        </Typography>

        {groups.length === 0 ? (
          <Typography sx={{ mt: 2, color: "#94A3B8" }}>
            No tienes páginas de grupos o negocios aún.
          </Typography>
        ) : (
          groups.map(page => (
            <PageCard
              key={page._id}
              page={page}
              type="PUBLISHED"
              onEdit={() => irA(`/user/crear-servicio/1?edit=${page._id}&type=group`)}
              onView={() => irA(`/user/pagina/${page._id}`)} // Adjust route
              onDelete={() => eliminar(page._id)}
            />
          ))
        )}
      </Box>
    </Box>
  );
};

export default TabPagina;
